import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-white py-16 px-4" data-id="element-59">
      <div className="max-w-4xl mx-auto flex flex-col md:flex-row items-center gap-8 md:gap-12 border-4 border-dashed border-gray-300 p-8 md:p-12 rounded-xl" data-id="element-60">
        <div className="flex-shrink-0" data-id="element-61">
          <div className="w-32 h-32 md:w-40 md:h-40 bg-yellow-100 rounded-full flex items-center justify-center border-4 border-yellow-400" data-id="element-62">
            <ShieldCheck className="w-16 h-16 md:w-20 md:h-20 text-yellow-600" data-id="element-63" />
          </div>
        </div>

        <div className="text-center md:text-left" data-id="element-64">
          <h2 className="text-3xl font-black text-gray-900 mb-4 font-['Oswald'] uppercase" data-id="element-65">
            Garantía sin riesgo
          </h2>
          <p className="text-xl text-gray-700 mb-4" data-id="element-66">
            Probalo durante 7 días. Si no te facilita la planificación y no
            mejora la comprensión en tu aula,
          </p>
          <p className="text-2xl font-bold text-gray-900" data-id="element-67">
            Te devolvemos el 100% del dinero.
          </p>
        </div>
      </div>
    </section>;
}